import create from 'zustand';
import { VendorState } from '../types/vendor.d';
import produce from 'immer';
import { devtools } from 'zustand/middleware';

const store = (set): VendorState => ({
    showComments: false,
    showFsnDetails: false,
    uploadedModels: [],
    setShowComments: (value: boolean) => {
        set(
            produce((state: VendorState) => {
                state.showComments = value;
            })
        );
    },
    setShowFsnDetails: (value: boolean) => {
        set(
            produce((state: VendorState) => {
                state.showFsnDetails = value;
            })
        );
    },

    setUploadedModels: (value: any) => {
        set(
            produce((state: VendorState) => {
                state.uploadedModels = value;
            })
        );
    }
});

export const useVendorStore = create<VendorState>(devtools(store));
